import { Component, OnInit } from '@angular/core';
import { Report } from '../../models/report';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-get-report-details',
  templateUrl: './get-report-details.component.html',
  styleUrls: ['./get-report-details.component.scss']
})
export class GetReportDetailsComponent implements OnInit {

  model = {} as Report;
  constructor(
    private route: Router,
    private diag: NbDialogRef<GetReportDetailsComponent>,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close(){
    this.diag.close();
  }

}
